export default __webpack_public_path__ + "static/media/icon-status-awaiting.1f8d115b.svg";